import api from './api';

const BASE = '/exchange';

export default {
  list: (params = {}) =>
    api.get(BASE, { params: { functionCode: 'EXCHANGE_VIEW', ...params } }).then(r => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'EXCHANGE_VIEW' } }).then(r => r.data),

  create: (data) =>
    api.post(BASE, { ...data, functionCode: 'EXCHANGE_CREATE' }).then(r => r.data),

  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'EXCHANGE_UPDATE' }).then(r => r.data),

  remove: (id) =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'EXCHANGE_DELETE' } }).then(r => r.data),
};
